<template lang="pug">
  .block
    WtRadioQuestionInput
      template(v-slot:label)
        p.is-size-4 {{ includePrompt }}
        p.is-size-6 {{ publicAndOpenNotice }}
        br
      template(v-slot:radioOne v-if="isAdmin")
        BRadio.test(
          v-model="action"
          native-value="add"
          size="is-large"
        ) Add {{ participantType }}s
      template(v-slot:radioTwo)
        BRadio.test(
          v-model="action"
          native-value="invite"
          size="is-large"
        ) Invite {{ participantType }}s
      template(v-slot:radioThree)
        BRadio.test(
          v-model="action"
          native-value="skip"
          size="is-large"
        ) No, skip this step
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import WtRadioQuestionInput from "@@/WtRadioQuestionInput/WtRadioQuestionInput";

const INVITE = "invite";
const ADD = "add";

export default {
  name: "ChallengeBuilderAddParticipantQuestions",

  components: { WtRadioQuestionInput },

  data() {
    return {
      action: ""
    };
  },

  computed: {
    ...mapGetters("challengeBuilder", ["formData"]),
    ...mapGetters("authMember", ["isAdmin"]),

    isAdminBuilder() {
      return /admin/.test(this.$route.path);
    },

    includeType() {
      return this.isAdmin ? `${ADD} or ${INVITE}` : INVITE;
    },

    includePrompt() {
      return `${this._.upperFirst(this.includeType)} ${
        this.participantType
      }s now`;
    },

    publicAndOpenNotice() {
      // Note: public & open are legacy.  We now keep them both the same.
      return this.formData.open.value
        ? "All members in your program will be able to see and join this challenge."
        : `Only members you ${this.includeType} will be able to see and join this challenge.`;
    },

    between() {
      return this.formData.between;
    },

    participantType() {
      return this.between.value === "groups" ? "team" : "member";
    }
  },

  watch: {
    action: {
      handler: function() {
        this.$emit("actionSelected", this.action);
      },
      immediate: true
    }
  },

  mounted() {
    if (this.isAdminBuilder) {
      this.updateFormData({ key: "addCreator", value: 0 });
    }
  },

  methods: {
    ...mapActions("challengeBuilder", ["updateOption", "updateFormData"])
  }
};
</script>
